/*
 * Copyright (C) 2017-2019 Dremio Corporation. This file is confidential and private property.
 */

const origin = window.location.origin;
// TODO: Fetch these from the server (https://dremio.atlassian.net/browse/DX-32432)
export const API_URL = `${origin.replace('login.', 'app.')}/ui`;
